//TODO:  Refactor so that we can synchronously check rights.    
// This implementation requires that rights be retrieved using loadPermissions before using objectHasPermission
//TODO:  Refactor so that permissions are stored in a keyed json object.   
// Translate from permissioncollection array.    This is for better performance!!!
//TODO: Make object and right comparisons case insensitive
import { Injectable, Injector } from '@angular/core';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { Observable, from, of } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';
import { ActionSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/action-search-dialog/action-search-dialog.component';
import { BrokerSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/broker-search-dialog.component';
import { ClaimSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/claim-search-dialog.component';
import { ClassCodeSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/classCode-search-dialog.component';
import { CodeSetSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/codeSet-search-dialog.component';
import { ConditionSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/condition-search-dialog.component';
import { ContractInterestThirdPartySearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/contract-interest-third-party-search-dialog.component';
import { ContractProfileSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/contract-profile-search-dialog.component';
import { ContractSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/contract-search-dialog.component';
import { DocumentSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/document-search-dialog.component';
import { EmployeeSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/employee-search-dialog.component';
import { EntitySearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/entity-search-dialog.component';
import { FormSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/form-search-dialog.component';
import { InvoiceSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/invoice-search-dialog.component';
import { PartyAgreementSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/party-agreement-search-dialog.component';
import { ProviderSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/provider-search-dialog.component';
import { ServiceSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/service-search-dialog/service-search-dialog.component';
import { StatementSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/statement-search-dialog.component';
import { SupplierSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/supplier-search-dialog.component';
import { TeamSetSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/team-set-search-dialog.component';
import { WorkgroupSearchDialogComponent } from '@Work/Accounts/proprietary/dialogs/workgroup-search-dialog.component';
import { DynamicContentModalComponent } from '@Work/Accounts/proprietary/dynamic-content-outlet/dynamic-content-modal.component';
import { AgreementSearchDialogComponent } from '../../../Views/Work/Accounts/proprietary/dialogs/agreement-search-dialog/agreement-search-dialog.component';
import { SearchResultType, SearchType } from './search.types';

@Injectable()
export class SearchService {
    advSearchModalRef: NgbModalRef;
    advSearchCallbackFunction: any;

    constructor(private modalService: NgbModal, private injector: Injector) { }

    //TODO: add type for options???
    //TODO: add type for search object???
    //TODO: mode to supply injector???
    //TODO: Refactor to use dynamic components rather than static declarations

    public openDialog(searchType: SearchType, callbackFunction: any, criteria = {}, options = {}) {
        let searchDialogComponent: any = null;

        switch (searchType) {
            //IMPORTANT!!!   When adding other objectTypes make sure to add to switch statement for modalRef.result below!!!!
            case SearchType.Contract:
                searchDialogComponent = ContractSearchDialogComponent;
                break;
            case SearchType.Claim:
                searchDialogComponent = ClaimSearchDialogComponent;
                break;
            case SearchType.Entity:
                searchDialogComponent = EntitySearchDialogComponent;
                break;
            case SearchType.Agreement:
                searchDialogComponent = AgreementSearchDialogComponent;
                break;
            case SearchType.PartyAgreement:
                searchDialogComponent = PartyAgreementSearchDialogComponent;
                break;
            case SearchType.Form:
                searchDialogComponent = FormSearchDialogComponent;
                break;
            case SearchType.Condition:
                searchDialogComponent = ConditionSearchDialogComponent;
                break;
            case SearchType.TeamSet:
                searchDialogComponent = TeamSetSearchDialogComponent;
                break;
            case SearchType.Document:
                searchDialogComponent = DocumentSearchDialogComponent;
                break;
            case SearchType.ContractProfile:
                searchDialogComponent = ContractProfileSearchDialogComponent;
                break;
            case SearchType.Employee:
                searchDialogComponent = EmployeeSearchDialogComponent;
                break;
            case SearchType.Workgroup:
                searchDialogComponent = WorkgroupSearchDialogComponent;
                break;
            case SearchType.IntegrationServiceConfig:
                searchDialogComponent = ServiceSearchDialogComponent;
                break;
            case SearchType.IntegrationActionConfig:
                searchDialogComponent = ActionSearchDialogComponent;
                break;
            case SearchType.Broker:
                searchDialogComponent = BrokerSearchDialogComponent;
                break;
            case SearchType.Supplier:
                searchDialogComponent = SupplierSearchDialogComponent;
                break;
            case SearchType.Provider:
                searchDialogComponent = ProviderSearchDialogComponent;
                break;
            case SearchType.CodeSet:
                searchDialogComponent = CodeSetSearchDialogComponent;
                break;
            case SearchType.ClassCode:
                searchDialogComponent = ClassCodeSearchDialogComponent;
                break;
            case SearchType.ContractInterestThirdParty:
                searchDialogComponent = ContractInterestThirdPartySearchDialogComponent;
                break;
            case SearchType.Invoice:
                searchDialogComponent = InvoiceSearchDialogComponent;
                break;
            case SearchType.Statement:
                searchDialogComponent = StatementSearchDialogComponent;
                break;
            default:
                console.error(`Unknown search type passed to ep-inline-search.  type=${searchType}`);
                return;
        }

        const modalRef: NgbModalRef = this.modalService.open(searchDialogComponent, {
            centered: true,
            size: 'lg',
            //injector: this.injector,     TODO -- do we need another mode with injector being passed?
            backdrop: 'static',
            windowClass: 'ep-modal-search-dialog',
            keyboard: false
        });

        modalRef.componentInstance.search(criteria, options);

        modalRef.result.then(
            (result) => {
                callbackFunction(result);
            },
            () => { }
        );
    }

    public openSearchDialog(searchType: SearchType, criteria = {}, options = {}): Observable<SearchResultType> {
        let searchDialogComponent: any = null;
        searchDialogComponent = this.getSearchModalComponent(searchType);

        const modalRef: NgbModalRef = this.modalService.open(searchDialogComponent, {
            centered: true,
            size: 'lg',
            backdrop: 'static',
            windowClass: 'ep-modal-search-dialog',
            keyboard: false
        });

        modalRef.componentInstance.search(criteria, options);

        return from(modalRef.result).pipe(
            map((result: SearchResultType) => of(result)),
            catchError((error) => of(error)),
            finalize(() => {
                searchDialogComponent = null;
            })
        );
    }

    getSearchModalComponent(searchType: SearchType): any {
        switch (searchType) {
            //IMPORTANT!!!   When adding other objectTypes make sure to add to switch statement for modalRef.result below!!!!
            case SearchType.Contract:
                return ContractSearchDialogComponent;
            case SearchType.Claim:
                return ClaimSearchDialogComponent;
            case SearchType.Entity:
                return EntitySearchDialogComponent;
            case SearchType.Agreement:
                return AgreementSearchDialogComponent;
            case SearchType.PartyAgreement:
                return PartyAgreementSearchDialogComponent;
            case SearchType.Form:
                return FormSearchDialogComponent;
            case SearchType.Condition:
                return ConditionSearchDialogComponent;
            case SearchType.TeamSet:
                return TeamSetSearchDialogComponent;
            case SearchType.Document:
                return DocumentSearchDialogComponent;
            case SearchType.ContractProfile:
                return ContractProfileSearchDialogComponent;
            case SearchType.Employee:
                return EmployeeSearchDialogComponent;
            case SearchType.Workgroup:
                return WorkgroupSearchDialogComponent;
            case SearchType.IntegrationServiceConfig:
                return ServiceSearchDialogComponent;
            case SearchType.IntegrationActionConfig:
                return ActionSearchDialogComponent;
            case SearchType.Broker:
                return BrokerSearchDialogComponent;
            case SearchType.Provider:
                return ProviderSearchDialogComponent;
            case SearchType.Supplier:
                return SupplierSearchDialogComponent;
            case SearchType.CodeSet:
                return CodeSetSearchDialogComponent;
            case SearchType.ClassCode:
                return ClassCodeSearchDialogComponent;
            default:
                console.error(`Unknown search type passed to ep-inline-search.  type=${searchType}`);
                return;
        }
    }

    openAdvancedSearchDialog(callbackFunction: any) {
        if (callbackFunction) {
            this.advSearchCallbackFunction = callbackFunction;
        }

        this.advSearchModalRef = this.modalService.open(DynamicContentModalComponent, {
            centered: true,
            size: 'lg',
            injector: this.injector,
            backdrop: 'static',
            windowClass: 'ep-modal-panel-double',
            keyboard: false
        });

        this.advSearchModalRef.componentInstance.showCloseButton = false;
        this.advSearchModalRef.componentInstance.type = 'AdvancedSearchDialogComponent';
    }

    closeAdvancedSearchDialog(result) {
        if (this.advSearchModalRef) {
            this.advSearchModalRef.close();
        }
        if (this.advSearchCallbackFunction) {
            this.advSearchCallbackFunction(result);
            this.advSearchCallbackFunction = null;
        }
    }
}
